import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faWheelchair, faCalculator } from '@fortawesome/sharp-regular-svg-icons';

import '../styles/componentStyles/GreyToggle.css';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';

function GreyToggle({ showCloseButton = true, closeButtonLabel, ...props }) {
  const { t } = useTranslation();
  const [on, setOn] = useState(true);
  const [icon, setIcon] = useState(null);
  const [heading, setHeading] = useState(null);
  const [text, setText] = useState(null);
  const [toggle, setToggle] = useState([]);
  const switchId = `whc-switch-${props.questionid === 'wheelchair' ? 'wheelchair' : 'steps'}`;

  useEffect(() => {
    if (props.questionid === 'wheelchair') {
      setIcon(faWheelchair);
      setHeading(t('T065'));
      setToggle([t('T066'), t('T067')]);
      setOn(!!props.wheelchair);
    } else if (props.steps) {
      setIcon(faCalculator);
      setHeading(() => (props.wheelchair ? t('T575') : t('T095')));
      setText(() => (props.wheelchair ? t('T576') : t('T096')));
      setToggle([t('T097'), t('T098')]);
    }
  }, [props.questionid, props.wheelchair, props.steps]);

  const handleToggle = (e) => {
    const newValue = e.target.checked;
    setOn(newValue);
    if (props.steps) props.toggleSteps();
    if (props.questionid === 'wheelchair') props.toggleWheelchair(newValue);
  };

  const closeToggle = () => {
    if (props.questionid === 'wheelchair') {
      props.closeWheelchairToggle();
    } else if (props.steps) {
      props.closeStepsToggle();
    }
  };

  return (
    <fieldset className="whc-cont fs-exclude">
      <legend className="sr-only">{heading}</legend>
      {icon && heading && toggle?.length > 0 && (
        <>
          {showCloseButton && (
            <Button
              type="button"
              className="quit"
              onClick={closeToggle}
              ariaLabel={closeButtonLabel}
              color="dark"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          )}
          <div className="whc-body">
            <div className="whc-heading">
              <FontAwesomeIcon icon={icon} /> {heading}
            </div>
            {text && <div className="whc-text">{text}</div>}
            {props.steps && (
              <span className="sr-only">{t('trackers.greyToggle.estimateSteps.info')}</span>
            )}
          </div>
          <div className="whc-slider fs-mask">
            <label htmlFor={switchId} className={`whc-switch ${on ? 'on' : 'off'}`}>
              <input
                id={switchId}
                type="checkbox"
                role="switch"
                aria-checked={on}
                aria-label={`${props.switchButtonLabel} ${t('trackers.greyToggle.toggle')}: ${on ? t('trackers.greyToggle.toggle.on') : t('trackers.greyToggle.toggle.off')} `}
                checked={on}
                onChange={handleToggle}
                className="whc-checkbox visually-hidden"
              />
              <div className="whc-slider-button" />
              <div className="whc-label">{on ? toggle[0] : toggle[1]}</div>
            </label>
          </div>
        </>
      )}
    </fieldset>
  );
}

export default GreyToggle;
